import React from 'react';
import { ArchiveIcon, EyeOffIcon, ServerIcon } from 'lucide-react';
import type { OutdoorCamera } from '../../../types/beheer';
const RECORDING: Record<OutdoorCamera['recording'], string> = {
  gebeurtenissen: 'Alleen gebeurtenissen',
  continu: 'Continu',
  uit: 'Opname uit'
};
export function CameraTile({
  camera
}: {
  camera: OutdoorCamera;
}) {
  const maskPct = `${camera.maskHeight * 100}%`;
  return <article aria-labelledby={`cam-${camera.id}`} className="flex flex-col" data-id="element-200" data-mp="3mbum7m0kvhey">
      <div className="relative aspect-video overflow-hidden rounded-2xl bg-night-800" data-id="element-201" data-mp="3qbuyb007fgiu">
        <img src={camera.image} alt={`Camerabeeld ${camera.name}, met privacymasker over ${camera.maskLabel.toLowerCase()}`} className="h-full w-full object-cover" data-id="element-202" data-mp="3vbr3h2kn1dzz" />
        {/* Privacy mask — rendered over the frame exactly where the camera blanks it */}
        <div className="absolute inset-x-0 top-0 flex items-end border-b border-dashed border-white/40 bg-night-950/95 px-3 pb-2" style={{
        height: maskPct
      }} data-id="element-203" data-mp="1akqkgomkuifn">
          <span className="flex items-center gap-1.5 text-[12px] font-medium text-ink-soft" data-id="element-204" data-mp="38zatmv6ow1gd">
            <EyeOffIcon className="h-3.5 w-3.5" aria-hidden data-id="element-205" data-mp="350bq9f0lwcr1" /> Privacymasker · {camera.maskLabel}
          </span>
        </div>
        <span className="absolute bottom-2.5 right-2.5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-night-950/85 px-2.5 py-1 text-[12px] font-medium text-ink" data-id="element-206" data-mp="2zy2wigfwt6nv">
          <ArchiveIcon className="h-3.5 w-3.5" aria-hidden data-id="element-207" data-mp="2q3aw74uy05pe" /> Bewaard {camera.retention}
        </span>
        <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-night-950/85 px-2.5 py-1 text-[12px] text-ink-soft" data-id="element-208" data-mp="2l9ghkfu72gx6">
          <span className="h-1.5 w-1.5 rounded-full bg-alarm" aria-hidden data-id="element-209" data-mp="2cbe7zbweafya" /> {RECORDING[camera.recording]}
        </span>
      </div>
      <div className="mt-3 flex items-baseline justify-between gap-3" data-id="element-210" data-mp="27agp0x3k9hvq">
        <h3 id={`cam-${camera.id}`} className="text-[15px] font-semibold text-ink" data-id="element-211" data-mp="22d6tr0thqbzz">
          {camera.name} <span className="font-normal text-ink-muted" data-id="element-212" data-mp="1snhzj7o9kxjn">· {camera.location}</span>
        </h3>
      </div>
      <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] text-ink-muted" data-id="element-213" data-mp="1xofivnl0fxmq">
        <span data-id="element-214" data-mp="1jp6dliycenxj">Laatst: {camera.lastEvent}</span>
        <span className="inline-flex items-center gap-1" data-id="element-215" data-mp="1npgj6ui83cbv">
          <ServerIcon className="h-3.5 w-3.5" aria-hidden data-id="element-216" data-mp="1npyoegmv50vx" /> Frigate, lokaal
        </span>
      </p>
    </article>;
}